import { BrandedTagInterface, hasResourceType, SplixerResourceTypes } from '@splixer/common';
import { nString } from '@hidat/huijs-common';
import { PlayerExtendedBranding } from './extended-branding.model';
import * as dayjs from 'dayjs';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

export class PlayerBrandedTag implements BrandedTagInterface, hasResourceType {
  resourceType = SplixerResourceTypes.BrandedTag;
  @Expose({ name: 'id' })
  id: number | undefined = undefined;
  @Expose({ name: 'code' })
  code: string | undefined = undefined;
  @Expose({ name: 'klass' })
  klass: string | undefined = undefined;
  @Expose({ name: 'name' })
  name: string | undefined = undefined;
  @Expose({ name: 'description' })
  description: nString = undefined;
  @Expose({ name: 'tag_line' })
  tagLine: nString = undefined;
  @Expose({ name: 'image_url' })
  imageUrl: nString = undefined;
  @Expose({ name: 'branding' })
  @Type(() => PlayerExtendedBranding)
  branding: PlayerExtendedBranding = {};
  @Expose({ name: 'priority' })
  priority: number | undefined = undefined;

  // Keep compiler happy
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Transform(dayjsTransformer, { toClassOnly: true })
  @Expose({ name: 'updated_at' }) //, DayJSConverter, true)
  updatedAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'status' }) //, Number, true)
  status = 100;
}
